'use strict'

import React,{Component} from 'react';

import FormattedContent from './FormattedContent.jsx';

var diff=require('diff');

class Removed extends React.Component {
  render() {
    return (
      <span style={{backgroundColor:"#FFE7E7", textDecoration:"line-through"}}><FormattedContent value={this.props.value}/></span>
    )
  }
}

class Added extends React.Component {
  render() {
    return (
      <span style={{backgroundColor:"#DDFADE"}}><FormattedContent value={this.props.value}/></span>
    );
  }
}

export default class Diff extends React.Component {
  render() {
    if (this.props.newValue!==undefined && this.props.newValue!==null && this.props.value===this.props.newValue) {
      return (
        <span>
          <FormattedContent value={this.props.value}/>
        </span>);
    } else {
      if (this.props.value!==undefined && this.props.value!==null && this.props.newValue!==undefined && this.props.newValue!==null) {
        var difference=diff.diffWords(this.props.value,this.props.newValue);
        return (
          <span>
            {difference.map((part,index)=>part.added ? <Added key={index} value={part.value}/> : part.removed ? <Removed key={index} value={part.value}/> : <span key={index}><FormattedContent value={part.value}/></span>)}
          </span>
        );
      } else {
        return (
          <span>
            <span>
              <Removed value={this.props.value}/>
            </span>
            <span>
              <Added value={this.props.newValue}/>
            </span>
          </span>
        );
      }
    }
  }
}



// WEBPACK FOOTER //
// ./views/components/Diff.jsx